/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Umbrella Authentication Api V1
 * OpenAPI spec version: 1.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
	BodyType,
	ErrorType,
} from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";

import { customInstance } from "../../../../../_packages/umbrella/lib/orval/custom-instance.ts";
import type { LoginModel, LoginResponseModel, MemberDto } from "../../models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getUmbracoApiV1MembersCurrent = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<MemberDto>(
		{ url: `/umbraco/api/v1/members/current`, method: "GET", signal },
		options,
	);
};

export const getGetUmbracoApiV1MembersCurrentQueryKey = () => {
	return [`/umbraco/api/v1/members/current`] as const;
};

export const getGetUmbracoApiV1MembersCurrentQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoApiV1MembersCurrentQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
	> = ({ signal }) => getUmbracoApiV1MembersCurrent(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1MembersCurrentQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
>;
export type GetUmbracoApiV1MembersCurrentQueryError = ErrorType<unknown>;

export function useGetUmbracoApiV1MembersCurrent<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1MembersCurrent<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
					TError,
					Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1MembersCurrent<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1MembersCurrent<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetUmbracoApiV1MembersCurrentQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUmbracoApiV1MembersCurrentSuspenseQueryOptions = <
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(options?: {
	query?: Partial<
		UseSuspenseQueryOptions<
			Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetUmbracoApiV1MembersCurrentQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
	> = ({ signal }) => getUmbracoApiV1MembersCurrent(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
		Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUmbracoApiV1MembersCurrentSuspenseQueryResult = NonNullable<
	Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>
>;
export type GetUmbracoApiV1MembersCurrentSuspenseQueryError =
	ErrorType<unknown>;

export function useGetUmbracoApiV1MembersCurrentSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options: {
		query: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1MembersCurrentSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUmbracoApiV1MembersCurrentSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUmbracoApiV1MembersCurrentSuspense<
	TData = Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
	TError = ErrorType<unknown>,
>(
	options?: {
		query?: Partial<
			UseSuspenseQueryOptions<
				Awaited<ReturnType<typeof getUmbracoApiV1MembersCurrent>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions =
		getGetUmbracoApiV1MembersCurrentSuspenseQueryOptions(options);

	const query = useSuspenseQuery(
		queryOptions,
		queryClient,
	) as UseSuspenseQueryResult<TData, TError> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};

	return withQueryKey(query, queryOptions.queryKey);
}

export const postUmbracoApiV1MembersLogin = (
	loginModel?: BodyType<LoginModel>,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<LoginResponseModel>(
		{
			url: `/umbraco/api/v1/members/login`,
			method: "POST",
			headers: { "Content-Type": "application/json" },
			data: loginModel,
			signal,
		},
		options,
	);
};

export const getPostUmbracoApiV1MembersLoginMutationKey = () =>
	["postUmbracoApiV1MembersLogin"] as const;

export const getPostUmbracoApiV1MembersLoginMutationOptions = <
	TError = ErrorType<void>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>,
		TError,
		PostUmbracoApiV1MembersLoginMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>,
	TError,
	PostUmbracoApiV1MembersLoginMutationVariables,
	TContext
> => {
	const mutationKey = getPostUmbracoApiV1MembersLoginMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>,
		PostUmbracoApiV1MembersLoginMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return postUmbracoApiV1MembersLogin(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostUmbracoApiV1MembersLoginMutationResult = NonNullable<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>
>;
export type PostUmbracoApiV1MembersLoginMutationBody =
	| BodyType<LoginModel>
	| undefined;
export type PostUmbracoApiV1MembersLoginMutationError = ErrorType<void>;
export type PostUmbracoApiV1MembersLoginMutationVariables = {
	data?: BodyType<LoginModel>;
};

export const usePostUmbracoApiV1MembersLogin = <
	TError = ErrorType<void>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>,
			TError,
			PostUmbracoApiV1MembersLoginMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogin>>,
	TError,
	PostUmbracoApiV1MembersLoginMutationVariables,
	TContext
> => {
	return useMutation(
		getPostUmbracoApiV1MembersLoginMutationOptions(options),
		queryClient,
	);
};
export const postUmbracoApiV1MembersLogout = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal,
) => {
	return customInstance<void>(
		{ url: `/umbraco/api/v1/members/logout`, method: "POST", signal },
		options,
	);
};

export const getPostUmbracoApiV1MembersLogoutMutationKey = () =>
	["postUmbracoApiV1MembersLogout"] as const;

export const getPostUmbracoApiV1MembersLogoutMutationOptions = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>,
		TError,
		void,
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>,
	TError,
	void,
	TContext
> => {
	const mutationKey = getPostUmbracoApiV1MembersLogoutMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>,
		void
	> = () => {
		return postUmbracoApiV1MembersLogout(requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type PostUmbracoApiV1MembersLogoutMutationResult = NonNullable<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>
>;

export type PostUmbracoApiV1MembersLogoutMutationError = ErrorType<unknown>;

export const usePostUmbracoApiV1MembersLogout = <
	TError = ErrorType<unknown>,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>,
			TError,
			void,
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof postUmbracoApiV1MembersLogout>>,
	TError,
	void,
	TContext
> => {
	return useMutation(
		getPostUmbracoApiV1MembersLogoutMutationOptions(options),
		queryClient,
	);
};
